<template>
  <div class="list-con h-full">
    <!--        名单列表 start        -->
    <div class="list-container flex flex-col align-center">
      <div
        v-for="item in pageData.diagRecords"
        :key="item.id"
        class="list-item w-full flex flex-row justify-between"
        @click="handleClickDiagRecord(item)"
      >
        <div class="name-con flex flex-row align-center">
          <img
            v-if="item.sexSign==='2'"
            class="profile"
            alt="头像"
            src="@/assets/treatment/profileFemale.png"
          >
          <img
            v-else
            class="profile"
            alt="头像"
            src="@/assets/treatment/profileMale.png"
          >
          <div class="name mr-5">{{ item.patientName }}</div>
          <!--          <el-tag size="mini">{{ item.stateSign|STATE_SIGN }}</el-tag>-->
        </div>
        <div class="info flex flex-row align-center">
          <!--          <div class="gender flex flex-row align-center">{{ item.sexSign === "1" ? "男" : "女" }}</div>-->
        </div>
      </div>
    </div>
    <!--        名单列表 end        -->
  </div>
</template>
<script>

import { findPage, getByCode } from '@/api/ik/data/dataApi'

export default {
  filters: {
    /**
     * 就诊记录状态
     * @param stateSign
     * @returns {string}
     * @constructor
     */
    STATE_SIGN(stateSign) {
      switch (stateSign) {
        case "1":
          return "待就诊"
        case "2":
          return "待配药"
        case "3":
          return "待结算"
        case "4":
          return "待取药"
        case "5":
          return "已完成"
        case "6":
          return "已关闭"
        default:
          return ""
      }
    }
  },
  inject: ["pageData"],
  mounted() {
    this.findDiagRecord()
  },
  methods: {
    /**
     * 查询处方记录
     */
    findDiagRecord() {
      const pd = {
        storeCode: this.pageData.storeCode,
        stateSign: "1"
      }
      findPage("clinic/treatment/treatment/medprescription", pd, 300, 1)
        .then(res => {
          this.pageData.diagRecords = res.data.list
        })
    },
    /**
     * 点击就诊记录
     * @param diagRecord 就诊记录
     */
    handleClickDiagRecord(diagRecord) {
      this.getActivePreDiagRecord(diagRecord.code)
      if (diagRecord.outOrdCode) {
        this.getOutList(diagRecord.outOrdCode)
      }
    },
    /**
     * 获取进行中的预诊记录
     * @param code
     */
    getActivePreDiagRecord(code) {
      const url = "clinic/treatment/treatment/medprescription"
      getByCode(url, code)
        .then(res => {
          this.pageData.prescription = res.data
        })
    },
    /**
     * 获取出库单
     * @param code
     */
    getOutList(code) {
      const url = "clinic/inventory/change/outord"
      getByCode(url, code)
        .then(res => {
          this.pageData.outOrd = res.data
        })
    }
  }
}
</script>

<style scoped lang="scss">
// 列表容器
.list-con {
  .list-search-input {
    width: 176px;
    height: 24px;
    background: #FFFFFF;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #E5E6EB;
    margin-bottom: 20px;
  }

  .list-container {
    height: 584px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 0;
    }

    .list-item {
      &:hover {
        cursor: pointer;
      }

      padding: 14px 12px;

      .name-con {
        .profile {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }

        .name {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: bold;
          font-size: 14px;
          color: #1D2129;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .info {
        .gender {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: normal;
          font-size: 14px;
          color: #86909C;
          line-height: 14px;
          text-align: right;
          font-style: normal;
          text-transform: none;
        }
      }

    }
  }
}

@media (min-height: 920px) {
  // 列表容器
  .list-con {
    .list-search-input {
      width: 176px;
      height: 24px;
      background: #FFFFFF;
      border-radius: 2px 2px 2px 2px;
      border: 1px solid #E5E6EB;
      margin-bottom: 20px;
    }

    .list-container {
      height: 72.5vh;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 0;
      }

      .list-item {
        &:hover {
          cursor: pointer;
        }

        padding: 14px 12px;

        .name-con {
          .profile {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          .name {
            font-family: PingFang SC, PingFang SC, serif;
            font-weight: bold;
            font-size: 14px;
            color: #1D2129;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .info {
          .gender {
            font-family: PingFang SC, PingFang SC, serif;
            font-weight: normal;
            font-size: 14px;
            color: #86909C;
            line-height: 14px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }

      }
    }
  }
}
</style>
